export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5589.f6ad4fda.jpg";